import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetCaseDocTypes = ({ caseId }: { caseId: string }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<string[]>(
    [QueryEntity.DocTypes, { caseId }],
    async () => {
      return fetch(`${APIBaseChronos}/api/case/${caseId}/doc-types`, fetchConfigGET).then((res) => res.json());
    },
    { enabled: Boolean(caseId), staleTime: Infinity, refetchOnWindowFocus: false },
  );
};
